module.exports = __webpack_public_path__ + "img/1.806d8516.png";